import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "services/apiList";

export const getSaleFoods = createAsyncThunk("sale/foods/list", async () => {
  const response = await axios.get(ApiList.saleFoods);
  const { result } = response.data;
  return result;
});

export const addSaleFood = createAsyncThunk(
  "sale/food/add",
  async (payload, { dispatch }) => {
    const response = await axios.post(ApiList.saleFoods, payload);
    const { result } = response.data;
    return result;
  }
);

export const getFoodOptions = () => async (dispatch) => {
  const response = await axios.get(ApiList.getFoodListUrl);
  const { result } = response.data;

  return dispatch(setFoodOptions(result));
};

const saleAdapter = createEntityAdapter({});

export const { selectAll: getFoods, selectById: getFood } =
  saleAdapter.getSelectors((state) => state.sale.saleSlice);

const saleSlice = createSlice({
  name: "saleFood",
  initialState: saleAdapter.getInitialState({
    foods: [],
    cart: [],
    foodOptions: [],
    openModal: false,
  }),
  reducers: {
    setFoodOptions: (state, action) => {
      state.foodOptions = action.payload;
    },
    setOpenModal: (state, action) => {
      state.openModal = action.payload;
    },
    setAddCartItem: (state, action) => {
      state.cart.push(action.payload);
    },
    removeCartItem: (state, action) => {
      const newItem = state.cart.splice(action.payload, 1);
      console.log(newItem);
      state.cart = newItem;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSaleFoods.fulfilled, (state, action) => {
      saleAdapter.setAll(state, action.payload);
    });
    builder.addCase(addSaleFood.fulfilled, (state, action) => {
      saleAdapter.addOne(state, action.payload);
      state.openModal = false;
    });
  },
});

export const { setOpenModal, setFoodOptions, setAddCartItem, removeCartItem } =
  saleSlice.actions;

export default saleSlice.reducer;
